/**
 * Stable `name` / `title` for every Wippy-generated srcdoc iframe.
 *
 * srcdoc iframes have no `src`, so dev tools and AI DOM inspectors show them as
 * anonymous `about:srcdoc` frames. Tagging each with
 * `name="wippy:<resourceType>:<resourceId>"` + a human `title` makes them
 * identifiable (which page/artifact a frame hosts) without opening the srcdoc.
 */

/** Machine-readable frame id, e.g. `wippy:page:app.views:main`. */
export function wippyFrameName(resourceType: string, resourceId: string): string {
  return `wippy:${resourceType}:${resourceId}`
}

/**
 * Human-readable frame title. Prefers an explicit resource label (e.g. an
 * artifact's title); falls back to `<resourceType>: <resourceId>` (page ids are
 * already meaningful, e.g. `page: app.views:main`).
 */
export function wippyFrameTitle(resourceType: string, resourceId: string, label?: string | null): string {
  const trimmed = label?.trim()
  return trimmed || `${resourceType}: ${resourceId}`
}
